import React from 'react'
import { MobXProviderContext } from 'mobx-react'
import { AppStoreType } from '../stores/AppStore'

interface Stores {
  app: AppStoreType
}

export const useStores = () => React.useContext(MobXProviderContext) as Stores
